import { useState, useEffect } from "react";
import type { ClassData } from "@/lib/api/types";
import { getClasses } from "@/lib/api/classes";

export const useClassesData = (
  token: string | null,
  schoolProfileId: string | null,
) => {
  const [classes, setClasses] = useState<ClassData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      if (!token || !schoolProfileId) {
        setLoading(false);
        return;
      }

      try {
        const classesData = await getClasses(token, schoolProfileId);

        // Business rule: exclude "Fundamental" level classes from this listing
        const filteredClasses = classesData.filter(
          (cls) => !cls.name?.toLowerCase().includes("fundamental"),
        );
        setClasses(filteredClasses);
      } catch (err) {
        setClasses([]);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, [token, schoolProfileId]);

  return { classes, loading };
};
